import { render, staticRenderFns } from "./RecordService.vue?vue&type=template&id=6ec5af86&scoped=true&"
import script from "./RecordService.vue?vue&type=script&scoped=true&lang=js&"
export * from "./RecordService.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./RecordService.vue?vue&type=style&index=0&id=6ec5af86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec5af86",
  null
  
)

export default component.exports